import { useMutation } from '@tanstack/react-query';
import { engineeringOperationsApi } from '../../apis';
import {
  InternalApiRerunPeriodicScenarioForPeriodRequest,
  InternalApiRerunPeriodicScenarioRequest,
  InternalApiRerunScenariosForPersonsByIdsRequest,
  InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest,
  InternalApiRerunScenariosForTransactionsByIdRangeRequest,
  InternalApiRerunScenariosForTransactionsByIdsRequest,
  InternalApiRerunScenariosForTransactionsByTimestampRangeRequest,
} from '../../api-internal';

export const useRerunPeriodicScenario = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunPeriodicScenarioRequest) =>
      engineeringOperationsApi.rerunPeriodicScenario({ internalApiRerunPeriodicScenarioRequest: request }),
  });

export const useRerunPeriodicScenarioForPeriod = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunPeriodicScenarioForPeriodRequest) =>
      engineeringOperationsApi.rerunPeriodicScenarioForPeriod({
        internalApiRerunPeriodicScenarioForPeriodRequest: request,
      }),
  });

export const useRerunScenariosForPersonsByIds = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunScenariosForPersonsByIdsRequest) =>
      engineeringOperationsApi.rerunScenariosForPersonsByIds({
        internalApiRerunScenariosForPersonsByIdsRequest: request,
      }),
  });

export const useRerunScenariosForTransactionsByCreatedTimeRange = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest) =>
      engineeringOperationsApi.rerunScenariosForTransactionsByCreatedTimeRange({
        internalApiRerunScenariosForTransactionsByCreatedTimeRangeRequest: request,
      }),
  });

export const useRerunScenariosForTransactionsByIdRange = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunScenariosForTransactionsByIdRangeRequest) =>
      engineeringOperationsApi.rerunScenariosForTransactionsByIdRange({
        internalApiRerunScenariosForTransactionsByIdRangeRequest: request,
      }),
  });

export const useRerunScenariosForTransactionsByIds = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunScenariosForTransactionsByIdsRequest) =>
      engineeringOperationsApi.rerunScenariosForTransactionsByIds({
        internalApiRerunScenariosForTransactionsByIdsRequest: request,
      }),
  });

export const useRerunScenariosForTransactionsByTimestampRange = () =>
  useMutation({
    mutationFn: (request: InternalApiRerunScenariosForTransactionsByTimestampRangeRequest) =>
      engineeringOperationsApi.rerunScenariosForTransactionsByTimestampRange({
        internalApiRerunScenariosForTransactionsByTimestampRangeRequest: request,
      }),
  });
